import { useEffect } from 'react';
import browser from '@openclassrooms/utils/browser';
import scrollToElement from '../../services/scrollToElement';

export default function ScrollTo({ children = null, selector = '', scrollOptions = {} }) {
  useEffect(() => {
    if (selector) {
      scrollToElement(browser.document.querySelector(selector), scrollOptions);
    }
  }, [selector, scrollOptions]);

  return children;
}
